export default __webpack_public_path__ + "static/media/Cootie (1609).23132a2d.jpg";